import { environment } from '../environments/environment';

export class Config {
	authApiUrl: string;
	authAppUrl: string;
	districtOneRosterApiUrl: string;
	clientId: string;
	responseType: string;
	scope: string;
	state: string;
	tokenName: string;
	config: any;

	gotopageKey: string;
	constructor(config?: any) {
		this.config = config || {};
		this.authApiUrl = this.config.authApiUrl || 'http://localhost:4000';
		this.authAppUrl = this.config.authAppUrl || 'http://localhost:14000/#';
		this.districtOneRosterApiUrl = this.config.districtOneRosterApiUrl || 'http://localhost:4001';
		this.tokenName = this.config.tokenName || 'token';
		this.clientId = this.config.clientId || 'ea2849e2-8e8c-487b-81e2-dd8bfb14e22e';
		this.responseType = this.config.responseType || 'token';
		this.scope = this.config.scope || 'all';
		this.state = this.config.state || '/dashboard';
		this.gotopageKey = 'gotopage';
	}

	loginUrl() {
		return this.districtOneRosterApiUrl + '/oauth2/login';
	}

	logoutUrl() {
		return this.districtOneRosterApiUrl + '/oauth2/logout';
	}

	saveGoToPage(path: string) {
		localStorage.setItem(this.gotopageKey, path);
	}

	goToPage(): string {
		return localStorage.getItem(this.gotopageKey);
	}

	removeLocalStorage() {
		localStorage.removeItem(this.gotopageKey);
	}
}

export function loadConfig(): Config {
	return new Config({
		clientId: environment.clientId,
		authApiUrl: environment.authApiUrl,
		authAppUrl: environment.authAppUrl,
		districtOneRosterApiUrl: environment.districtOneRosterApiUrl,
	});
}
